
export enum ExportType {
    Excel = "Excel",
    CSV = "CSV",
    ExcelRAW = "Excel (raw data)",
    CSVRAW = "CSV (raw data)",
    PDF = "PDF",
    PNG = "PNG",
}

export class ExportOption {
    types: ExportType[];
    chart: string;

    constructor(types: ExportType[], chart: string) {
        this.types = types;
        this.chart = chart;
    }
}